import React, { useCallback } from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';

import { useSearch } from './SearchContext';
import { Asset } from './types';
import ReferencePickerPlugin from '../../types/ReferencePickerPlugin';

const AssetsPickerNoSearchResults: ReferencePickerPlugin<Asset>['CustomPickerNoSearchResults'] =
  ({ clearFilters }) => {
    const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
    const { setSearchTerm } = useSearch();

    const onClick = useCallback(() => {
      setSearchTerm('');
      clearFilters();
    }, [setSearchTerm, clearFilters]);

    return (
      <EmptyState
        illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_PHOTO_GREY}
        title={T.translate('NO_SEARCH_RESULTS_TITLE')}
        description={T.translate('NO_SEARCH_RESULTS_DESCRIPTION')}
      >
        <LinkButton onClick={onClick}>{T.translate('CLEAR_SEARCH')}</LinkButton>
      </EmptyState>
    );
  };

export default AssetsPickerNoSearchResults;
